/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notifications_Prep_Moment_MorningInputs */



/**
* | output |
* | --- |
* | "The morning itself" |
*
* @param {Notifications_Prep_Moment_MorningInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const notifications_prep_moment_morning = /** @type {((inputs?: Notifications_Prep_Moment_MorningInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Prep_Moment_MorningInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("De ochtend zelf")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Le matin même")
	return /** @type {LocalizedString} */ ("The morning itself")
});